import moment, { Moment } from 'moment'

export function toValidTimeString(time: string | Moment, format: string): string {
  if (moment.isMoment(time)) {
    return time.format(format)
  }
  return time
}